<template>
  <div class="generate-btn-box" :class="{  }">
    <div
        class="generate-btn"
        v-bind:class="{ 'disabled': isDone === false || this.loading}"
        @click="applyImage"
    >
      {{ 'Continue' | trans }}

      <i v-if="!loading" class="far fa-arrow-right font-size-150"></i>
      <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import {EVENT_JOB_APPLY_IMAGE, EVENT_JOB_START} from '../../events/job.events';
import {EventBus} from '../../events/event.bus';
import currentJob from './../../mixins/current_job.mixin';
import CoinSVG from './../../../form/icons/CoinSVG.vue';
import Analytics from "../../util/Analytics";
import {JOB_STATE_PROCESSING} from "../../const/job.const";
import StageManager from "../../manager/StageManager";
import {APP_GENERIC_ERROR} from "../../events/app.events";

export default {
  name: 'ContinueBtn',
  props: {},
  components: {CoinSVG},
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    applyImage() {
      if (this.currentJob.state === JOB_STATE_PROCESSING) {
        return;
      }
      EventBus.$emit(EVENT_JOB_APPLY_IMAGE, {});
    }
  },
  computed: {
    isDone() {
      return this.activeStage.preview === true && this.image !== '';
    },
  },
};
</script>
<style lang="scss">
.credit-cost-badge {
  display: flex;
  padding: 0px 5px;
  align-items: center;
  border-radius: 4px;
  background: #fa0;
  gap: 4px;
  color: #2e2e2e;
  font-size: 14px;
}

.generate-btn-box-mobile {
  border-top: 1px solid #595959;
  background: #272727;
  padding: 10px 20px !important;

  .generate-btn {
    height: 55px;
  }
}

.generate-btn-box {
  padding: 20px;
  position: relative;

  .credit-cost-badge {
    position: absolute;
    right: 35px;
  }
}

.generate-btn {
  background: #1266f1;
  color: white;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 17.5px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #1161e5;
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
